export const getApiFetching = ({ apiFetching }) => apiFetching;
export const getFetchingUpdater = ({ setFetching }) => setFetching;
export const getUberLoaderVisibility = ({ showUberLoader }) => showUberLoader;
export const getUberLoaderVisibilityUpdater = ({ setShowUberLoader }) =>
  setShowUberLoader;
